import React from 'react'

export default function NotFoundPage() {
  return (
    <div>
      <h1>404 Page not found</h1>
    </div>
  )
}
